// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3WKfC","signatureButtonsRight":"ModalSign_signatureButtonsRight__2ERkX"};